import { userAvatar } from 'Services/avatarGenerator'
import { getZodiacIcon } from 'Services/zodiacSign'
import { default as locale } from 'date-fns__legacy__/locale/pt'
import format from 'date-fns__legacy__/format'
import parse from 'date-fns__legacy__/format'

const formatBirthday = (birthDate) => {
  return format(birthDate, 'DD [de] MMMM [de] YYYY', { locale })
}

/**
 * @param {ApiCompanyUser} data
 * @return {CompanyUser}
 */
export const parseUser = (data) => {
  const birthDate = parse(data.birthday)

  return {
    id: data.id,
    name: data.name,
    email: data.email,
    role: data.role,
    avatar: userAvatar('', data.name),
    birthday: data.birthday ? formatBirthday(birthDate) : null,
    birthdaySign: data.birthday ? getZodiacIcon(birthDate) : null,
    isActive: data.isActive,
  }
}